module.exports = ".btnUrl{\r\n\twidth: 116px;\r\n\t/*width: 120px;*/\r\n}\r\n.btnOpciones{\r\n\twidth: 124px;\r\n}\r\n.labelTextarea{\r\n\tbottom:97px;\r\n}"